export default __webpack_public_path__ + "static/media/warning--slippery-road-surface--g1.be37c309.png";